<template>
  <textarea class="e-textarea"
            type="text"
            :class="hasError ? 'is-invalid' : ''"
            :name="name"
            ref="element"
            :placeholder="getPlaceholder"
            v-bind:disabled="disabled"
            v-model="model[name]"
  ></textarea>
</template>

<script>
  export default {
    name: 'e-textarea',
    data() {
      return {
        error: null
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null,
        required: true
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      }
    },
    computed: {
      getPlaceholder(){
        if(this.placeholder === null){
          return 'Введите текст'
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if(this.formValidator){
        this.formValidator.subscribeInput(this)
      }
    },
    methods: {
      getElement(){
        return this.$refs.element
      },
      validate () {
        let msg = ''
        if (this.required) {
          if(!this.model[this.name]){
            this.model[this.name] = ''
          }
          if(this.model[this.name].length < 1){
            msg+= 'Укажите текст. '
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
